import { render, staticRenderFns } from "./StudentViewStudentInfoCard.vue?vue&type=template&id=6513056d&"
import script from "./StudentViewStudentInfoCard.vue?vue&type=script&lang=js&"
export * from "./StudentViewStudentInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports